
/*========================================
        Imports!!!
=========================================*/

/*--css--*/
import Header from './header.js';
import Footer from './footer.js';
import '../assets/css/gallery.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

/*--Gallery images--*/

import equip1 from '../assets/gallery/img1.webp';
import equip2 from '../assets/gallery/img2.webp';
import equip3 from '../assets/gallery/img3.webp';
import equip4 from '../assets/gallery/img4.webp';
import equip5 from '../assets/gallery/img5.webp';
import equip6 from '../assets/gallery/img6.webp';
import equip7 from '../assets/gallery/img7.webp';
import equip8 from '../assets/gallery/img8.webp';
import equip9 from '../assets/gallery/img9.webp';
import equip10 from '../assets/gallery/img10.webp';
import equip11 from '../assets/gallery/img11.webp';
import equip12 from '../assets/gallery/img12.webp';
import equip13 from '../assets/gallery/img13.webp';
import equip14 from '../assets/gallery/img14.webp';
import equip15 from '../assets/gallery/img15.webp';
import equip16 from '../assets/gallery/img16.webp';
import equip17 from '../assets/gallery/img17.webp';
import equip18 from '../assets/gallery/img18.webp';
import equip19 from '../assets/gallery/img19.webp';

import movie1 from '../assets/gallery/help1.webm';
import movie2 from '../assets/gallery/help2.webm';
import movie3 from '../assets/gallery/lodz.webm';
import movie4 from '../assets/gallery/zbiorniki1.webm';
import movie5 from '../assets/gallery/nurek.webm';
import movie6 from '../assets/gallery/help3.webm';

import movie11 from '../assets/gallery/help1.mp4';
import movie21 from '../assets/gallery/help2.mp4';
import movie31 from '../assets/gallery/lodz.mp4';
import movie41 from '../assets/gallery/zbiorniki1.mp4';
import movie51 from '../assets/gallery/nurek.mp4';
import movie61 from '../assets/gallery/help3.mp4';

/*========================================
        Functions!!!
=========================================*/

function Gallery() {
    return (
        <>
            <article className='GalleryContainer'>
                <section className='GalleryContent'>
                    <Row className='cytat'>
                        <h1>Z nami bezpieczeństwo staje się codziennością</h1>
                        <i>"Nie musisz być lekarzem, by uratować komuś życie. Wystarczy, że masz wiedzę, odwagę i właściwy sprzęt"</i>
                    </Row>
                    <Row>
                        <Col lg={4} md={4} sm={12}>
                            <img src={equip1} alt='equipment'/>
                            <img src={equip2} alt='equipment'/>
                            <video autoPlay loop muted playsInline>
                                <source src={movie6} type="video/webm" />
                                <source src={movie61} type="video/mp4" />
                            </video>
                            <img src={equip5} alt='equipment'/>
                            <video autoPlay loop muted playsInline>
                                <source src={movie4} type="video/webm" />     
                                <source src={movie41} type="video/mp4" />
                            </video>
                            <img src={equip6} alt='equipment'/>
                            <img src={equip7} alt='equipment' />
                            <img src={equip3} alt='equipment'/>
                        </Col>

                        <Col lg={4} md={4} sm={12}>
                            <img src={equip8} alt='equipment'/>
                            <img src={equip9} alt='equipment'/>
                            <img src={equip10} alt='equipment'/>
                            <video autoPlay loop muted playsInline>
                                <source src={movie3} type="video/webm" />
                                <source src={movie31} type="video/mp4" />
                            </video>
                            <img src={equip11} alt='equipment'/>
                            <img src={equip12} alt='equipment'/>
                            <img src={equip14} alt='equipment'/>
                            <img src={equip13} alt='equipment' />
                        </Col>

                        <Col lg={4} md={4} sm={12}>
                            <img src={equip15} alt='equipment'/>
                            <video autoPlay loop muted playsInline>
                                <source src={movie1} type="video/webm" />
                                <source src={movie11} type="video/mp4" />
                            </video>
                            <img src={equip16} alt='equipment'/>
                            <img src={equip17} alt='equipment'/>
                            <img src={equip18} alt='equipment'/>
                            <video autoPlay loop muted playsInline>
                                <source src={movie5} type="video/mp4" />
                                <source src={movie51} type="video/mp4" />
                            </video>
                            <img src={equip19} alt='equipment'/>
                            <video autoPlay loop muted playsInline>
                                <source src={movie2} type="video/webm" />
                                <source src={movie21} type="video/mp4" />
                            </video>
                            <img src={equip11} alt='equipment' />
                        </Col>
                    </Row>
                </section>
            </article>  
        </>
    );
}

function Album() {
    return (
        <>
          <Header />
          <Gallery/>
          <Footer/>
        </>
    ); 
}



export default Album;